<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <b-button-group>
              <b-button
                  :variant="activeTab === 'names' ? 'primary' : 'outline-primary'"
                  @click="setTab('names')"
              >
                Side Bet Names
              </b-button>
              <b-button
                  :variant="activeTab === 'opposite' ? 'primary' : 'outline-primary'"
                  @click="setTab('opposite')"
              >
                Opposite Bets
              </b-button>
            </b-button-group>
          </div>
        </div>
      </div>
    </div>

    <sidebet-names v-if="activeTab === 'names'" embedded></sidebet-names>
    <opposite-sidebets v-else embedded></opposite-sidebets>
  </div>
</template>

<script>
import {getRouteIcon, ROUTE_LIMITS} from "../../utils/routerIcons";
import SidebetNames from "./SidebetNames.vue";
import OppositeSidebets from "./OppositeSidebets.vue";

export default {
  components: {
    SidebetNames,
    OppositeSidebets
  },
  data() {
    return {
      activeTab: this.$route.query.tab === 'opposite' ? 'opposite' : 'names',
    }
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_LIMITS),
  },
  methods: {
    setTab(tab) {
      if (this.activeTab === tab) {
        return;
      }

      this.activeTab = tab;

      if (this.$route.query.tab !== tab) {
        this.$router.replace({query: {...this.$route.query, tab}}).catch(() => {});
      }
    }
  }
}
</script>
